import en from './en';
import ru from './ru';
import uz from './uz';

export const languages = { en, ru, uz };
export const languageList = ['en', 'ru', 'uz'];
export default languages;
